import React, { Fragment, Suspense, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { messages } from '../../messages';
import { useAIAnswerContext } from '../ai-answer-context';
import { AIAnswerContentWaryAndBrandSection } from '../ai-answer-footer/ai-answer-footer';
import { onAIAnswerLoadingDialogShown } from '../analytics';
import { NLPSearchResultFormat } from '../types';
import { AIAnswerLoadingStream } from './ai-answer-loading-stream';
import GeneratingAnimation from './generating-animation';
import { AIAnswerSearchLoadingBorder, GeneratingContainer, GeneratingText } from './styled';
export var AIAnswerLoadingDialog = function AIAnswerLoadingDialog() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  useEffect(function () {
    fireAnalyticsEvent(onAIAnswerLoadingDialogShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(SmartAnswerLoadingDialog, null);
};
var SmartAnswerLoadingDialog = function SmartAnswerLoadingDialog() {
  var _useAIAnswerContext2 = useAIAnswerContext(),
    partialResponse = _useAIAnswerContext2.partialResponse;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (!partialResponse || (partialResponse === null || partialResponse === void 0 ? void 0 : partialResponse.format) !== NLPSearchResultFormat.MARKDOWN) {
    return /*#__PURE__*/React.createElement(AIAnswerSearchLoadingBorder, {
      isStreaming: false
    }, /*#__PURE__*/React.createElement(GeneratingContainer, null, /*#__PURE__*/React.createElement(GeneratingAnimation, {
      alt: formatMessage(messages.ai_answer_generating_icon_alt_text)
    }), /*#__PURE__*/React.createElement(GeneratingText, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_generating_text))), /*#__PURE__*/React.createElement(AIAnswerContentWaryAndBrandSection, null));
  }
  return /*#__PURE__*/React.createElement(AIAnswerSearchLoadingBorder, {
    isStreaming: true
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(AIAnswerLoadingStream, {
    markdown: partialResponse.partialNlpResult
  }), /*#__PURE__*/React.createElement(AIAnswerContentWaryAndBrandSection, null))));
};